<template>
  <Divider
    v-bind="$attrs"
    :size="props.size"
    :direction="resolvedDirection"
    :shade="resolvedShade"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { Divider } from '@p-utilities/vue'
import type { DividerSize, DividerDirection, DividerShade } from '@p-utilities/vue'

const props = defineProps<{
  size?: DividerSize
  direction?: DividerDirection
  shade?: DividerShade
  vertical?: boolean
  color?: 'light' | 'medium'
}>()

const resolvedDirection = computed<DividerDirection>(() => {
  if (props.direction) return props.direction
  return props.vertical ? 'vertical' : 'horizontal'
})

const resolvedShade = computed<DividerShade>(() => {
  if (props.shade) return props.shade
  return props.color ?? 'light'
})
</script>
